import { render, staticRenderFns } from "./TaskMonitor.vue?vue&type=template&id=08f5ffc8"
import script from "./TaskMonitor.vue?vue&type=script&lang=js"
export * from "./TaskMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports